// Lightweight i18n for Shakti Wings — EN / Hindi / Marathi
// Keep this file as the single source of truth for translations.
// For any string not in this map, t(key) returns the key itself (safe fallback).

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "hi", label: "हिन्दी", short: "हिंदी" },
  { code: "mr", label: "मराठी", short: "मराठी" },
];

export const TRANSLATIONS = {
  en: {
    // Brand
    "brand.name": "Shakti Wings",
    // Header / Nav
    "nav.features": "Features",
    "nav.community": "Community",
    "nav.stories": "Stories",
    "nav.login": "Login",
    "nav.join": "Join Now",
    "nav.marketplace": "Marketplace",
    "nav.events": "Events",
    "nav.leaders": "Leaders",
    "nav.find_leader": "Find a Leader",
    "nav.stars": "Stars",
    "nav.guide": "Guide",
    "nav.dashboard": "Dashboard",
    "nav.orders": "My Orders",
    "nav.wallet": "Wallet",
    "nav.rewards": "Rewards",
    "nav.profile": "Profile",
    "nav.founder_card": "Founder Digital Card",
    "nav.about": "About Shakti Wings",
    "nav.admin": "Admin",
    "nav.logout": "Logout",
    // Hero
    "hero.label": "Built by women, for women",
    "hero.title.1": "Every Woman Deserves",
    "hero.title.2": "Income, Identity",
    "hero.title.3": "& Independence.",
    "hero.subtitle": "Join India's most empowering community commerce platform. Earn from home, learn business skills, sell your products, and rise as a leader — all in one place.",
    "hero.mission.label": "Our Mission",
    "hero.mission.text": "To unlock economic freedom, identity & sisterhood for every Indian woman — from the smallest village to the largest metro.",
    "hero.mission.highlight": "economic freedom",
    "hero.cta.primary": "Join Now — It's Free",
    "hero.cta.secondary": "I'm Already a Member",
    "hero.trust": "{count} women thriving",
    "hero.earnings.label": "Total Earnings",
    "hero.earnings.value": "{amount} Earned",
    "hero.earnings.sub": "by our member community",
    // Features section
    "features.label": "Everything in one place",
    "features.title.1": "One platform.",
    "features.title.2": "Everything",
    "features.title.3": "a woman needs to thrive.",
    "features.subtitle": "From your first product sale to leading thousands of women — every tool you need, in one elegant home.",
    "features.explore": "Explore",
    // Community section
    "community.label": "Our Sisterhood",
    "community.title.1": "When one woman rises,",
    "community.title.2": "we all rise.",
    "community.subtitle": "Get mentored by State Leaders. Make friends in every city. Share wins, celebrate milestones, and pull each other up — because real change happens together, never alone.",
    "community.point.1.title": "Daily wins & stories",
    "community.point.1.desc": "A feed full of real entrepreneurial journeys, no influencer noise.",
    "community.point.2.title": "City meetups & state summits",
    "community.point.2.desc": "Meet your tribe over chai, share notes, leave inspired.",
    "community.point.3.title": "Mentorship by senior leaders",
    "community.point.3.desc": "1-on-1 guidance from women who've built businesses from their kitchen.",
    "community.point.4.title": "Safe space, zero judgement",
    "community.point.4.desc": "Verified members only. No trolls, no spam — just sisterhood.",
    "community.quote": "I found my voice, my income, and my soul-sisters here.",
    "community.quote.by": "— A Shakti Mom",
    // Testimonials section
    "testimonials.label": "Real Stories",
    "testimonials.title.1": "Women who",
    "testimonials.title.2": "rose",
    "testimonials.title.3": "with us",
    "testimonials.subtitle": "From homemakers to ₹1L/month earners — every story is real, every name is real.",
    // CTA section
    "cta.badge": "Your wings are waiting",
    "cta.title.2": "Rise like never before.",
    "cta.button": "Create My Free Account",
    "cta.trust": "Free forever · No credit card · 30 seconds",
    // Language switcher
    "lang.switch": "Language",
    // Marketplace
    "mp.label": "Marketplace",
    "mp.title.1": "Shop from",
    "mp.title.2": "women-owned",
    "mp.title.3": "businesses",
    "mp.subtitle": "Every purchase empowers a woman entrepreneur.",
    "mp.sell": "Sell a Product",
    "mp.list.title": "List a new product",
    "mp.field.name": "Product Name",
    "mp.field.desc": "Description",
    "mp.field.price": "Offer Price (₹)",
    "mp.field.mrp": "MRP (₹, optional)",
    "mp.field.stock": "Stock",
    "mp.field.category": "Category",
    "mp.field.image": "Image",
    "mp.publish": "Publish Listing",
    "mp.cat.all": "All",
    "mp.view": "View",
    "mp.add": "Add",
    "mp.add_to_cart": "Add to Cart",
    "mp.own_product": "This is your product",
    "mp.your_product": "Your Product",
    "mp.cod_note": "Cash on Delivery · Safe & secure checkout",
    "mp.empty.title": "No products yet in this category",
    "mp.empty.sub": "Be the first to list something. Every sale supports a woman entrepreneur.",
    "mp.sold": "sold",
    "mp.upload_img": "Upload product image",
    // Community feed
    "feed.label": "Community Feed",
    "feed.title.1": "Your",
    "feed.title.2": "sisterhood",
    "feed.subtitle": "Share wins, ask for help, lift others.",
    "feed.placeholder": "Share a win, story, or question...",
    "feed.add_photo": "Add photo",
    "feed.share": "Share",
    "feed.empty.title": "No posts yet",
    "feed.empty.sub": "Be the first to share something with the community.",
    "feed.loading": "Loading community feed...",
    "feed.comment_placeholder": "Add a comment...",
    // Events
    "ev.label": "Events",
    "ev.title.1": "Where Shakti",
    "ev.title.2": "meets Shakti",
    "ev.subtitle": "Live meetups, online bootcamps, and city summits.",
    "ev.online": "Online",
    "ev.offline": "Offline",
    "ev.inperson": "In-Person",
    "ev.free": "Free",
    "ev.registered": "Registered",
    "ev.view_details": "View Details",
    "ev.pass": "Pass",
    "ev.register": "Register",
    "ev.empty.title": "No upcoming events",
    "ev.empty.sub": "Check back soon — new meetups and bootcamps are added every week.",
    "ev.you_registered": "You're registered",
    "ev.detail.date": "Date",
    "ev.detail.venue": "Venue",
    "ev.detail.seats": "Seats",
    "ev.detail.price": "Price",
    "ev.view_pass": "View Your Event Pass",
    "ev.register_btn": "Register for this event",
    "ev.pass.title": "Your Event Pass",
    "ev.pass.note": "Show this QR code at the event entry.",
    "ev.open_to_all": "Open for all members",
    "ev.pay_at_venue": "Pay at venue (COD)",
    // Leadership
    "ld.label": "Leadership Path",
    "ld.title.1": "Rise. Lead.",
    "ld.title.2": "Inspire.",
    "ld.subtitle": "Grow your team, unlock bonuses, and become a force in your city.",
    "ld.path_heading": "The Shakti Path",
    "ld.path_hint": "Tap any role to see benefits & requirements",
    "ld.next_milestone": "Your Next Milestone",
    "ld.next_become": "Become a",
    "ld.team": "Your Team",
    "ld.team.sub": "Women you've referred",
    "ld.bonus": "Leadership Bonus",
    "ld.bonus.sub": "Earned from team activity",
    "ld.rank": "Your Rank",
    "ld.rank.next": "Next:",
    "ld.rank.top": "Top of the path 👑",
    "ld.rank.signin": "Sign in to see your rank",
    "ld.tab.team": "My Team",
    "ld.tab.board": "Leaderboard",
    "ld.empty_signin.title": "Sign in to see your team",
    "ld.empty_signin.sub": "Track everyone you've referred and your leadership bonuses.",
    "ld.empty_team.title": "No team members yet",
    "ld.empty_team.sub": "Share your referral code from the Dashboard to grow your team and unlock leadership bonuses.",
    "ld.detail.unlock": "How to unlock",
    "ld.detail.benefits": "Benefits",
    "ld.detail.resp": "Responsibilities",
    "ld.points": "points",
    // Recognition
    "rc.label": "Hall of Fame",
    "rc.title.1": "Celebrating our",
    "rc.title.2": "Shakti stars",
    "rc.subtitle": "Honoring the women lifting others with their leadership, craft, and grit.",
    "rc.tab.leaders": "Top Leaders",
    "rc.tab.sellers": "Top Sellers",
    "rc.tab.badges": "Badges",
    "rc.team_bonus": "Team Bonus",
    "rc.points": "Points",
    "rc.sales": "Sales",
    "rc.products": "Products",
    "rc.loading.leaders": "Loading top leaders...",
    "rc.loading.sellers": "Loading top sellers...",
    "rc.loading.badges": "Loading achievements...",
    "rc.empty.leaders.title": "No leaders yet",
    "rc.empty.leaders.sub": "Be the first to rise and lead your city.",
    "rc.empty.sellers.title": "No sales yet",
    "rc.empty.sellers.sub": "Be the first to make a sale and earn your spot here.",
    "rc.empty.badges.title": "No badges earned yet",
    "rc.empty.badges.sub": "Start posting, selling, and learning to unlock your first badge.",
    "rc.members_earned": "members earned this",
    // Earnings
    "earn.label": "Earnings",
    "earn.title.1": "Three income streams.",
    "earn.title.2": "One platform.",
    "earn.subtitle": "Earn from product sales, referrals, and your leadership team — withdraw to your bank any time after ₹100.",
    "earn.cta": "Start Earning",
    // Common
    "common.loading": "Loading...",
    // Hero stats
    "stats.sisters": "Active Sisters",
    "stats.earnings": "Earnings Distributed",
    "stats.cities": "Cities Reached",
    // Auth-required prompts (used by useRequireAuth)
    "auth.signin_to": "Sign in to {action}",
    "auth.action.sell": "list a product",
    "auth.action.cart": "add items to cart",
    "auth.action.post": "share with the community",
    "auth.action.like": "like posts",
    "auth.action.comment": "comment",
    "auth.action.events": "register for events",
    "auth.action.continue": "continue",
    // Toasts
    "toast.product_listed": "Product listed!",
    "toast.product_failed": "Failed to create product",
    "toast.product_added_cart": "{name} added to cart",
    "toast.own_product": "This is your own product",
    "toast.post_shared": "Post shared with the community!",
    "toast.post_failed": "Failed to post",
    "toast.like_failed": "Could not update like. Please try again.",
    "toast.comment_failed": "Could not post comment. Please try again.",
    "toast.event_registered": "Registered! See you there.",
    "toast.event_failed": "Failed to register",
    "toast.products_failed": "Failed to load products",
    "toast.events_failed": "Failed to load events",
    "toast.feed_failed": "Failed to load feed",
    "toast.name_price_required": "Name and price required",
    // Auth page
    "auth.back": "Back to home",
    "auth.welcome_back": "Welcome back",
    "auth.join.1": "Join the",
    "auth.join.2": "sisterhood",
    "auth.sub.login": "Sign in to continue your journey",
    "auth.sub.signup": "Start earning, learning & leading today",
    "auth.tab.login": "Login",
    "auth.tab.signup": "Sign Up",
    "auth.tab.otp": "OTP",
    "auth.field.email": "Email",
    "auth.field.password": "Password",
    "auth.field.name": "Full Name",
    "auth.field.mobile": "Mobile",
    "auth.field.city": "City",
    "auth.field.state": "State",
    "auth.field.referral": "Referral Code (optional)",
    "auth.field.otp_mobile": "Mobile Number",
    "auth.field.otp_code": "Enter OTP",
    "auth.placeholder.mobile": "10-digit mobile",
    "auth.placeholder.otp": "6-digit OTP",
    "auth.btn.signin": "Sign In",
    "auth.btn.create": "Create Account",
    "auth.btn.send_otp": "Send OTP",
    "auth.btn.verify": "Verify & Continue",
    "auth.try_demo": "Try a sample member login",
    "auth.otp.note": "We'll send a 6-digit code to verify your number.",
    "auth.otp.code_is": "Your verification code:",
    "auth.otp.change_number": "Change number",
    // Phone-first passwordless auth (v2)
    "auth.tab.mobile": "Mobile OTP",
    "auth.tab.email": "Email",
    "auth.sub.otp": "Sign in or create your account with your mobile number.",
    "auth.field.mobile_label": "Mobile Number",
    "auth.field.language": "Preferred Language",
    "auth.otp.enter_hint": "10-digit Indian mobile. We'll send a 6-digit OTP.",
    "auth.otp.sent": "OTP sent to {mobile}",
    "auth.otp.sent_mock": "OTP (dev): {otp}",
    "auth.otp.sent_to": "OTP sent to",
    "auth.otp.dev_mock_hint": "Development OTP (auto-filled hint)",
    "auth.otp.never_share": "Never share this OTP with anyone. Shakti Wings staff will never ask for it.",
    "auth.otp.not_received": "Didn't get it? Resend",
    "auth.otp.resend_in": "Resend in",
    "auth.otp.try_whatsapp": "Try WhatsApp OTP instead",
    "auth.otp.verified": "Mobile verified",
    "auth.terms.prefix": "I agree to the",
    "auth.terms.tos": "Terms of Service",
    "auth.terms.and": "and",
    "auth.terms.privacy": "Privacy Policy",
    "auth.terms.suffix": ".",
    "auth.terms.age": "I confirm I am 18 or older.",
    // Legal pages
    "legal.home": "Home",
    "legal.back_home": "Back to Home",
    "legal.last_updated": "Last updated",
    "legal.terms": "Terms",
    "legal.privacy": "Privacy",
    "legal.delete_account": "Delete Account",
    "auth.err.login_failed": "Login failed. Please try again.",
    "auth.err.signup_failed": "Signup failed. Please try again.",
    "auth.err.send_failed": "Couldn't send OTP. Please try again.",
    "auth.err.invalid_otp": "Invalid OTP",
    "auth.err.terms_required": "Please agree to the Terms and Privacy Policy to continue.",
    // User Guide & Help Center
    "guide.badge": "User Guide & Help Center",
    "guide.heading.before": "How to use",
    "guide.heading.after": "",
    "guide.intro": "Everything you need to know — how to sell, how to buy, how to earn, our community rules, and answers to common questions.",
    "guide.step": "Step",
    "guide.lang_label": "भाषा चुनें / भाषा निवडा / Select Language",
    "guide.join_cta": "Join Shakti Wings Now",
    "guide.whatsapp_help": "Still have questions? WhatsApp us at",
    "guide.empty": "Guide is being prepared. Please check back soon.",
  },

  hi: {
    "brand.name": "शक्ति विंग्स",
    "nav.features": "विशेषताएँ",
    "nav.community": "समुदाय",
    "nav.stories": "कहानियाँ",
    "nav.login": "लॉगिन",
    "nav.join": "अभी जुड़ें",
    "nav.marketplace": "बाज़ार",
    "nav.events": "कार्यक्रम",
    "nav.leaders": "लीडर्स",
    "nav.find_leader": "लीडर खोजें",
    "nav.stars": "सितारे",
    "nav.guide": "मार्गदर्शन",
    "nav.dashboard": "डैशबोर्ड",
    "nav.orders": "मेरे ऑर्डर",
    "nav.wallet": "वॉलेट",
    "nav.rewards": "इनाम",
    "nav.profile": "प्रोफ़ाइल",
    "nav.founder_card": "फ़ाउंडर डिजिटल कार्ड",
    "nav.about": "शक्ति विंग्स के बारे में",
    "nav.admin": "एडमिन",
    "nav.logout": "लॉगआउट",

    "hero.label": "महिलाओं द्वारा, महिलाओं के लिए",
    "hero.title.1": "हर महिला की हक़दार है",
    "hero.title.2": "आय, पहचान",
    "hero.title.3": "और स्वतंत्रता।",
    "hero.subtitle": "भारत के सबसे सशक्त सामुदायिक मंच से जुड़िए। घर बैठे कमाइए, बिज़नेस सीखिए, अपने प्रोडक्ट्स बेचिए और एक लीडर बनिए — सब कुछ एक ही जगह।",
    "hero.mission.label": "हमारा मिशन",
    "hero.mission.text": "हर भारतीय महिला के लिए आर्थिक आज़ादी, पहचान और बहनापा — सबसे छोटे गाँव से लेकर सबसे बड़े शहर तक।",
    "hero.mission.highlight": "आर्थिक आज़ादी",
    "hero.cta.primary": "अभी जुड़ें — बिल्कुल मुफ़्त",
    "hero.cta.secondary": "मैं पहले से सदस्य हूँ",
    "hero.trust": "{count} महिलाएँ आगे बढ़ रही हैं",
    "hero.earnings.label": "कुल कमाई",
    "hero.earnings.value": "{amount} की कमाई",
    "hero.earnings.sub": "हमारे सदस्य समुदाय द्वारा",

    "features.label": "सब कुछ एक जगह",
    "features.title.1": "एक मंच।",
    "features.title.2": "सब कुछ",
    "features.title.3": "जो एक महिला को आगे बढ़ने के लिए चाहिए।",
    "features.subtitle": "पहली बिक्री से लेकर हज़ारों महिलाओं का नेतृत्व करने तक — हर ज़रूरी टूल, एक ख़ूबसूरत जगह पर।",
    "features.explore": "देखें",

    "community.label": "हमारा बहनापा",
    "community.title.1": "जब एक महिला उठती है,",
    "community.title.2": "हम सब उठती हैं।",
    "community.subtitle": "स्टेट लीडर्स से मार्गदर्शन पाइए। हर शहर में नई दोस्त बनाइए। जीतें साझा कीजिए, मील के पत्थर मनाइए और एक-दूसरे को आगे बढ़ाइए।",
    "community.point.1.title": "रोज़ की सफलताएँ और कहानियाँ",
    "community.point.1.desc": "असली उद्यमी सफरों से भरा फ़ीड — कोई इन्फ्लुएंसर शोर नहीं।",
    "community.point.2.title": "शहर मीटअप और राज्य सम्मेलन",
    "community.point.2.desc": "चाय पर अपनी टीम से मिलिए, नोट्स साझा कीजिए, प्रेरित होकर लौटिए।",
    "community.point.3.title": "वरिष्ठ लीडर्स से मेंटरशिप",
    "community.point.3.desc": "अपनी रसोई से बिज़नेस खड़ा करने वाली महिलाओं से 1-ऑन-1 मार्गदर्शन।",
    "community.point.4.title": "सुरक्षित जगह, बिना किसी भेदभाव",
    "community.point.4.desc": "सिर्फ़ वेरिफ़ाइड सदस्य। न ट्रोल, न स्पैम — सिर्फ़ बहनापा।",
    "community.quote": "यहाँ मुझे अपनी आवाज़, अपनी कमाई और अपनी सच्ची बहनें मिलीं।",
    "community.quote.by": "— एक शक्ति माँ",

    "testimonials.label": "असली कहानियाँ",
    "testimonials.title.1": "वो महिलाएँ जो",
    "testimonials.title.2": "उठीं",
    "testimonials.title.3": "हमारे साथ",
    "testimonials.subtitle": "गृहिणी से ₹1 लाख/महीना कमाने वाली तक — हर कहानी सच्ची, हर नाम सच्चा।",

    "cta.badge": "आपके पंख आपका इंतज़ार कर रहे हैं",
    "cta.title.2": "पहले से कहीं ऊँची उड़ान भरिए।",
    "cta.button": "मेरा मुफ़्त खाता बनाएँ",
    "cta.trust": "हमेशा मुफ़्त · कोई क्रेडिट कार्ड नहीं · 30 सेकंड में",

    "lang.switch": "भाषा",
    // Marketplace
    "mp.label": "बाज़ार",
    "mp.title.1": "खरीदिए",
    "mp.title.2": "महिलाओं द्वारा संचालित",
    "mp.title.3": "व्यवसायों से",
    "mp.subtitle": "हर खरीद एक महिला उद्यमी को सशक्त बनाती है।",
    "mp.sell": "अपना सामान बेचें",
    "mp.list.title": "नया प्रोडक्ट लिस्ट करें",
    "mp.field.name": "प्रोडक्ट का नाम",
    "mp.field.desc": "विवरण",
    "mp.field.price": "ऑफर मूल्य (₹)",
    "mp.field.mrp": "एमआरपी (₹, वैकल्पिक)",
    "mp.field.stock": "स्टॉक",
    "mp.field.category": "श्रेणी",
    "mp.field.image": "तस्वीर",
    "mp.publish": "लिस्टिंग प्रकाशित करें",
    "mp.cat.all": "सभी",
    "mp.view": "देखें",
    "mp.add": "जोड़ें",
    "mp.add_to_cart": "कार्ट में जोड़ें",
    "mp.own_product": "यह आपका अपना प्रोडक्ट है",
    "mp.your_product": "आपका प्रोडक्ट",
    "mp.cod_note": "कैश ऑन डिलीवरी · सुरक्षित चेकआउट",
    "mp.empty.title": "इस श्रेणी में अभी कोई प्रोडक्ट नहीं",
    "mp.empty.sub": "पहले लिस्ट करने वाली बनिए। हर बिक्री एक महिला उद्यमी का सहयोग है।",
    "mp.sold": "बिक चुके",
    "mp.upload_img": "प्रोडक्ट की तस्वीर अपलोड करें",
    "feed.label": "समुदाय फ़ीड",
    "feed.title.1": "आपका",
    "feed.title.2": "बहनापा",
    "feed.subtitle": "जीतें साझा कीजिए, मदद माँगिए, दूसरों को आगे बढ़ाइए।",
    "feed.placeholder": "अपनी जीत, कहानी या सवाल साझा कीजिए...",
    "feed.add_photo": "फ़ोटो जोड़ें",
    "feed.share": "साझा करें",
    "feed.empty.title": "अभी कोई पोस्ट नहीं",
    "feed.empty.sub": "समुदाय के साथ साझा करने वाली पहली बनिए।",
    "feed.loading": "समुदाय फ़ीड लोड हो रहा है...",
    "feed.comment_placeholder": "टिप्पणी जोड़ें...",
    "ev.label": "कार्यक्रम",
    "ev.title.1": "जहाँ शक्ति",
    "ev.title.2": "शक्ति से मिलती है",
    "ev.subtitle": "लाइव मीटअप्स, ऑनलाइन बूटकैम्प और शहर सम्मेलन।",
    "ev.online": "ऑनलाइन",
    "ev.offline": "ऑफ़लाइन",
    "ev.inperson": "व्यक्तिगत",
    "ev.free": "मुफ़्त",
    "ev.registered": "पंजीकृत",
    "ev.view_details": "विवरण देखें",
    "ev.pass": "पास",
    "ev.register": "पंजीकरण",
    "ev.empty.title": "कोई आगामी कार्यक्रम नहीं",
    "ev.empty.sub": "जल्द ही नए मीटअप्स और बूटकैम्प जोड़े जाएँगे।",
    "ev.you_registered": "आप पंजीकृत हैं",
    "ev.detail.date": "तारीख़",
    "ev.detail.venue": "स्थान",
    "ev.detail.seats": "सीटें",
    "ev.detail.price": "मूल्य",
    "ev.view_pass": "अपना पास देखें",
    "ev.register_btn": "इस कार्यक्रम के लिए पंजीकरण करें",
    "ev.pass.title": "आपका इवेंट पास",
    "ev.pass.note": "प्रवेश पर यह QR कोड दिखाइए।",
    "ev.open_to_all": "सभी सदस्यों के लिए खुला",
    "ev.pay_at_venue": "स्थान पर भुगतान (COD)",
    "ld.label": "नेतृत्व पथ",
    "ld.title.1": "उठो। नेतृत्व करो।",
    "ld.title.2": "प्रेरणा बनो।",
    "ld.subtitle": "अपनी टीम बढ़ाइए, बोनस पाइए और अपने शहर की शक्ति बनिए।",
    "ld.path_heading": "शक्ति पथ",
    "ld.path_hint": "लाभ और शर्तें देखने के लिए किसी भी भूमिका पर टैप कीजिए",
    "ld.next_milestone": "आपका अगला लक्ष्य",
    "ld.next_become": "बनिए एक",
    "ld.team": "आपकी टीम",
    "ld.team.sub": "जिन महिलाओं को आपने जोड़ा",
    "ld.bonus": "लीडरशिप बोनस",
    "ld.bonus.sub": "टीम गतिविधि से अर्जित",
    "ld.rank": "आपकी रैंक",
    "ld.rank.next": "अगला:",
    "ld.rank.top": "शीर्ष पर 👑",
    "ld.rank.signin": "अपनी रैंक देखने के लिए साइन इन कीजिए",
    "ld.tab.team": "मेरी टीम",
    "ld.tab.board": "लीडरबोर्ड",
    "ld.empty_signin.title": "अपनी टीम देखने के लिए साइन इन कीजिए",
    "ld.empty_signin.sub": "जिन्हें आपने जोड़ा है उन्हें और अपने बोनस को ट्रैक कीजिए।",
    "ld.empty_team.title": "अभी कोई टीम सदस्य नहीं",
    "ld.empty_team.sub": "अपना रेफ़रल कोड शेयर कीजिए और लीडरशिप बोनस अनलॉक कीजिए।",
    "ld.detail.unlock": "कैसे अनलॉक करें",
    "ld.detail.benefits": "लाभ",
    "ld.detail.resp": "ज़िम्मेदारियाँ",
    "ld.points": "पॉइंट्स",
    "rc.label": "गौरव दीवार",
    "rc.title.1": "हमारी",
    "rc.title.2": "शक्ति सितारे",
    "rc.subtitle": "उन महिलाओं को नमन जो अपने नेतृत्व, हुनर और जज़्बे से दूसरों को ऊपर उठाती हैं।",
    "rc.tab.leaders": "शीर्ष नेत्रियाँ",
    "rc.tab.sellers": "शीर्ष विक्रेताएँ",
    "rc.tab.badges": "बैज",
    "rc.team_bonus": "टीम बोनस",
    "rc.points": "पॉइंट्स",
    "rc.sales": "बिक्री",
    "rc.products": "प्रोडक्ट्स",
    "rc.loading.leaders": "शीर्ष नेत्रियाँ लोड हो रही हैं...",
    "rc.loading.sellers": "शीर्ष विक्रेताएँ लोड हो रही हैं...",
    "rc.loading.badges": "उपलब्धियाँ लोड हो रही हैं...",
    "rc.empty.leaders.title": "अभी कोई नेत्रियाँ नहीं",
    "rc.empty.leaders.sub": "अपने शहर में पहले उठने और नेतृत्व करने वाली बनिए।",
    "rc.empty.sellers.title": "अभी कोई बिक्री नहीं",
    "rc.empty.sellers.sub": "पहली बिक्री करके अपनी जगह पाइए।",
    "rc.empty.badges.title": "अभी कोई बैज नहीं",
    "rc.empty.badges.sub": "पोस्ट कीजिए, बेचिए और सीखिए — अपना पहला बैज पाइए।",
    "rc.members_earned": "सदस्यों ने यह कमाया",
    "earn.label": "कमाई",
    "earn.title.1": "तीन आय स्रोत।",
    "earn.title.2": "एक मंच।",
    "earn.subtitle": "प्रोडक्ट बिक्री, रेफ़रल और लीडरशिप टीम से कमाइए — ₹100 के बाद बैंक में निकालिए।",
    "earn.cta": "कमाई शुरू कीजिए",
    "common.loading": "लोड हो रहा है...",
    "stats.sisters": "सक्रिय बहनें",
    "stats.earnings": "वितरित कमाई",
    "stats.cities": "शहर जुड़े",
    "auth.signin_to": "{action} के लिए साइन इन कीजिए",
    "auth.action.sell": "अपना सामान बेचने",
    "auth.action.cart": "कार्ट में जोड़ने",
    "auth.action.post": "समुदाय में साझा करने",
    "auth.action.like": "पोस्ट को लाइक करने",
    "auth.action.comment": "टिप्पणी करने",
    "auth.action.events": "कार्यक्रम के लिए पंजीकरण करने",
    "auth.action.continue": "जारी रखने",
    "toast.product_listed": "प्रोडक्ट लिस्ट हो गया!",
    "toast.product_failed": "प्रोडक्ट जोड़ने में समस्या",
    "toast.product_added_cart": "{name} कार्ट में जुड़ गया",
    "toast.own_product": "यह आपका अपना प्रोडक्ट है",
    "toast.post_shared": "पोस्ट समुदाय में साझा हुई!",
    "toast.post_failed": "पोस्ट करने में समस्या",
    "toast.like_failed": "लाइक अपडेट नहीं हुआ। फिर से कोशिश कीजिए।",
    "toast.comment_failed": "टिप्पणी पोस्ट नहीं हुई। फिर से कोशिश कीजिए।",
    "toast.event_registered": "पंजीकरण हो गया! आप वहाँ मिलेंगी।",
    "toast.event_failed": "पंजीकरण नहीं हो सका",
    "toast.products_failed": "प्रोडक्ट्स लोड नहीं हो सके",
    "toast.events_failed": "कार्यक्रम लोड नहीं हो सके",
    "toast.feed_failed": "फ़ीड लोड नहीं हो सकी",
    "toast.name_price_required": "नाम और मूल्य ज़रूरी है",
    "auth.back": "होम पर वापस",
    "auth.welcome_back": "वापस स्वागत है",
    "auth.join.1": "शक्ती विंग्स परिवार से",
    "auth.join.2": "जुड़िए",
    "auth.sub.login": "अपनी यात्रा जारी रखने के लिए साइन इन कीजिए",
    "auth.sub.signup": "कमाइए, सीखिए और नेतृत्व कीजिए — आज ही शुरू कीजिए",
    "auth.tab.login": "लॉगिन",
    "auth.tab.signup": "साइन अप",
    "auth.tab.otp": "OTP",
    "auth.field.email": "ईमेल",
    "auth.field.password": "पासवर्ड",
    "auth.field.name": "पूरा नाम",
    "auth.field.mobile": "मोबाइल",
    "auth.field.city": "शहर",
    "auth.field.state": "राज्य",
    "auth.field.referral": "रेफ़रल कोड (वैकल्पिक)",
    "auth.field.otp_mobile": "मोबाइल नंबर",
    "auth.field.otp_code": "OTP दर्ज कीजिए",
    "auth.placeholder.mobile": "10-अंकों का मोबाइल",
    "auth.placeholder.otp": "6-अंकों का OTP",
    "auth.btn.signin": "साइन इन",
    "auth.btn.create": "खाता बनाइए",
    "auth.btn.send_otp": "OTP भेजिए",
    "auth.btn.verify": "सत्यापित करें",
    "auth.try_demo": "नमूना सदस्य लॉगिन आज़माइए",
    "auth.otp.note": "हम आपके नंबर पर 6-अंकों का कोड भेजेंगे।",
    "auth.otp.code_is": "आपका सत्यापन कोड:",
    "auth.otp.change_number": "नंबर बदलें",
    // Phone-first passwordless auth (v2)
    "auth.tab.mobile": "मोबाइल OTP",
    "auth.tab.email": "ईमेल",
    "auth.sub.otp": "अपने मोबाइल नंबर से लॉगिन करें या नया अकाउंट बनाएं।",
    "auth.field.mobile_label": "मोबाइल नंबर",
    "auth.field.language": "पसंदीदा भाषा",
    "auth.otp.enter_hint": "10-अंकों का भारतीय मोबाइल। हम 6-अंकों का OTP भेजेंगे।",
    "auth.otp.sent": "{mobile} पर OTP भेजा गया",
    "auth.otp.sent_mock": "OTP (dev): {otp}",
    "auth.otp.sent_to": "OTP भेजा गया",
    "auth.otp.dev_mock_hint": "डेवलपमेंट OTP (auto-filled)",
    "auth.otp.never_share": "यह OTP कभी किसी से शेयर न करें। Shakti Wings टीम आपसे OTP नहीं मांगती।",
    "auth.otp.not_received": "नहीं मिला? दोबारा भेजें",
    "auth.otp.resend_in": "दोबारा भेजने में",
    "auth.otp.try_whatsapp": "WhatsApp OTP आज़माएं",
    "auth.otp.verified": "मोबाइल सत्यापित",
    "auth.terms.prefix": "मैं",
    "auth.terms.tos": "सेवा शर्तों",
    "auth.terms.and": "और",
    "auth.terms.privacy": "गोपनीयता नीति",
    "auth.terms.suffix": " से सहमत हूं।",
    "auth.terms.age": "मैं 18 वर्ष या अधिक की हूं।",
    // Legal pages
    "legal.home": "होम",
    "legal.back_home": "होम पर वापस",
    "legal.last_updated": "अंतिम अद्यतन",
    "legal.terms": "शर्तें",
    "legal.privacy": "गोपनीयता",
    "legal.delete_account": "खाता हटाएं",
    "auth.err.login_failed": "लॉगिन विफल। कृपया दोबारा कोशिश करें।",
    "auth.err.signup_failed": "साइनअप विफल। कृपया दोबारा कोशिश करें।",
    "auth.err.send_failed": "OTP नहीं भेजा जा सका। कृपया दोबारा कोशिश करें।",
    "auth.err.invalid_otp": "गलत OTP",
    "auth.err.terms_required": "जारी रखने के लिए कृपया शर्तों और गोपनीयता नीति से सहमत हों।",
    // User Guide & Help Center
    "guide.badge": "यूज़र गाइड और हेल्प सेंटर",
    "guide.heading.before": "",
    "guide.heading.after": " कैसे इस्तेमाल करें",
    "guide.intro": "आपको जो कुछ भी जानना है — कैसे बेचें, कैसे खरीदें, कैसे कमाएं, हमारे कम्युनिटी नियम, और आम सवालों के जवाब।",
    "guide.step": "स्टेप",
    "guide.lang_label": "भाषा चुनें / भाषा निवडा / Select Language",
    "guide.join_cta": "अभी Shakti Wings जॉइन करें",
    "guide.whatsapp_help": "अभी भी सवाल हैं? हमें WhatsApp करें",
    "guide.empty": "गाइड तैयार हो रही है। कृपया थोड़ी देर बाद देखें।",
  },

  mr: {
    "brand.name": "शक्ती विंग्ज",
    "nav.features": "वैशिष्ट्ये",
    "nav.community": "समुदाय",
    "nav.stories": "कहाण्या",
    "nav.login": "लॉगिन",
    "nav.join": "आत्ताच सामील व्हा",
    "nav.marketplace": "बाजारपेठ",
    "nav.events": "कार्यक्रम",
    "nav.leaders": "नेत्या",
    "nav.find_leader": "नेत्या शोधा",
    "nav.stars": "तारका",
    "nav.guide": "मार्गदर्शक",
    "nav.dashboard": "डॅशबोर्ड",
    "nav.orders": "माझे ऑर्डर",
    "nav.wallet": "वॉलेट",
    "nav.rewards": "इनाम",
    "nav.profile": "प्रोफाइल",
    "nav.founder_card": "फाउंडर डिजिटल कार्ड",
    "nav.about": "शक्ति विंग्सबद्दल",
    "nav.admin": "ॲडमिन",
    "nav.logout": "लॉगआउट",

    "hero.label": "महिलांनी, महिलांसाठी",
    "hero.title.1": "प्रत्येक स्त्रीला हवी आहे",
    "hero.title.2": "कमाई, ओळख",
    "hero.title.3": "आणि स्वातंत्र्य.",
    "hero.subtitle": "भारतातील सर्वात प्रेरणादायी महिला समुदायाशी जोडा. घरबसल्या कमवा, व्यवसाय शिका, आपली उत्पादने विका आणि एक नेत्या बना — सर्व काही एका ठिकाणी.",
    "hero.mission.label": "आमचे ध्येय",
    "hero.mission.text": "प्रत्येक भारतीय स्त्रीला आर्थिक स्वातंत्र्य, ओळख आणि बहीणभाव मिळावा — सर्वात लहान गावापासून सर्वात मोठ्या शहरापर्यंत.",
    "hero.mission.highlight": "आर्थिक स्वातंत्र्य",
    "hero.cta.primary": "आत्ताच सामील व्हा — विनामूल्य",
    "hero.cta.secondary": "मी आधीच सदस्य आहे",
    "hero.trust": "{count} महिला यशस्वी होत आहेत",
    "hero.earnings.label": "एकूण कमाई",
    "hero.earnings.value": "{amount} ची कमाई",
    "hero.earnings.sub": "आमच्या सदस्य समुदायाद्वारे",

    "features.label": "सर्व काही एका ठिकाणी",
    "features.title.1": "एक व्यासपीठ.",
    "features.title.2": "सर्व काही",
    "features.title.3": "जे महिलेला पुढे जाण्यासाठी हवे.",
    "features.subtitle": "पहिल्या विक्रीपासून हजारो महिलांचे नेतृत्व करण्यापर्यंत — प्रत्येक गरजेची साधने, एका सुंदर ठिकाणी.",
    "features.explore": "पाहा",

    "community.label": "आपलं बहीणपण",
    "community.title.1": "जेव्हा एक स्त्री उठते,",
    "community.title.2": "तेव्हा आपण सर्व उठतो.",
    "community.subtitle": "राज्य नेत्यांकडून मार्गदर्शन घ्या. प्रत्येक शहरात नवीन मैत्रिणी बनवा. यश शेअर करा, मैलाचे दगड साजरे करा आणि एकमेकींना पुढे न्या.",
    "community.point.1.title": "रोजच्या यशकथा",
    "community.point.1.desc": "खऱ्या उद्योजिकांचा प्रवास दाखवणारा फीड — कोणताही इन्फ्लुएंसर गोंगाट नाही.",
    "community.point.2.title": "शहर भेटी आणि राज्य संमेलने",
    "community.point.2.desc": "चहावर भेटा, अनुभव शेअर करा, प्रेरित होऊन परत जा.",
    "community.point.3.title": "ज्येष्ठ नेत्यांकडून मार्गदर्शन",
    "community.point.3.desc": "स्वयंपाकघरातून व्यवसाय उभारलेल्या महिलांकडून १-१ मार्गदर्शन.",
    "community.point.4.title": "सुरक्षित जागा, कोणताही भेदभाव नाही",
    "community.point.4.desc": "फक्त पडताळणी केलेले सदस्य. ट्रोल नाही, स्पॅम नाही — फक्त बहीणपण.",
    "community.quote": "इथे मला माझा आवाज, माझी कमाई आणि माझ्या खऱ्या बहिणी मिळाल्या.",
    "community.quote.by": "— एक शक्ती माय",

    "testimonials.label": "खऱ्या कहाण्या",
    "testimonials.title.1": "त्या महिला ज्या",
    "testimonials.title.2": "उठल्या",
    "testimonials.title.3": "आमच्यासोबत",
    "testimonials.subtitle": "गृहिणीपासून ₹१ लाख/महिना कमावणाऱ्यांपर्यंत — प्रत्येक कहाणी खरी, प्रत्येक नाव खरे.",

    "cta.badge": "तुमचे पंख तुमची वाट पाहत आहेत",
    "cta.title.2": "आजवर कधीही नव्हते तसे उडा.",
    "cta.button": "माझे विनामूल्य खाते तयार करा",
    "cta.trust": "नेहमी विनामूल्य · क्रेडिट कार्ड नको · ३० सेकंदात",

    "lang.switch": "भाषा",
    // Marketplace
    "mp.label": "बाजारपेठ",
    "mp.title.1": "खरेदी करा",
    "mp.title.2": "महिलांच्या",
    "mp.title.3": "व्यवसायांकडून",
    "mp.subtitle": "प्रत्येक खरेदी एका महिला उद्योजिकेला बळ देते.",
    "mp.sell": "आपलं उत्पादन विका",
    "mp.list.title": "नवीन उत्पादन सूचीबद्ध करा",
    "mp.field.name": "उत्पादनाचे नाव",
    "mp.field.desc": "तपशील",
    "mp.field.price": "ऑफर किंमत (₹)",
    "mp.field.mrp": "एमआरपी (₹, ऐच्छिक)",
    "mp.field.stock": "स्टॉक",
    "mp.field.category": "श्रेणी",
    "mp.field.image": "फोटो",
    "mp.publish": "सूची प्रकाशित करा",
    "mp.cat.all": "सर्व",
    "mp.view": "पाहा",
    "mp.add": "जोडा",
    "mp.add_to_cart": "कार्टमध्ये जोडा",
    "mp.own_product": "हे आपलंच उत्पादन आहे",
    "mp.cod_note": "कॅश ऑन डिलिव्हरी · सुरक्षित खरेदी",
    "mp.empty.title": "या श्रेणीत अजून कोणतीही उत्पादने नाहीत",
    "mp.empty.sub": "पहिल्या होऊन यादीत भर घाला. प्रत्येक विक्री एका महिलेला मदत करते.",
    "mp.sold": "विकले",
    "mp.upload_img": "उत्पादनाचा फोटो अपलोड करा",
    "feed.label": "समुदाय फीड",
    "feed.title.1": "आपलं",
    "feed.title.2": "बहीणपण",
    "feed.subtitle": "यश शेअर करा, मदत मागा, इतरांना पुढे न्या.",
    "feed.placeholder": "आपलं यश, कथा किंवा प्रश्न शेअर करा...",
    "feed.add_photo": "फोटो जोडा",
    "feed.share": "शेअर करा",
    "feed.empty.title": "अजून कोणतीही पोस्ट नाही",
    "feed.empty.sub": "समुदायासोबत शेअर करणारी पहिली व्हा.",
    "feed.loading": "समुदाय फीड लोड होत आहे...",
    "feed.comment_placeholder": "टिप्पणी जोडा...",
    "ev.label": "कार्यक्रम",
    "ev.title.1": "जिथे शक्ती",
    "ev.title.2": "शक्तीला भेटते",
    "ev.subtitle": "थेट भेटीगाठी, ऑनलाइन बूटकॅम्प आणि शहर संमेलने.",
    "ev.online": "ऑनलाइन",
    "ev.offline": "ऑफलाइन",
    "ev.inperson": "प्रत्यक्ष",
    "ev.free": "विनामूल्य",
    "ev.registered": "नोंदणी झाली",
    "ev.view_details": "तपशील पाहा",
    "ev.pass": "पास",
    "ev.register": "नोंदणी करा",
    "ev.empty.title": "लवकरच येणारे कार्यक्रम नाहीत",
    "ev.empty.sub": "लवकरच नवीन भेटीगाठी आणि बूटकॅम्प जोडले जातील.",
    "ev.you_registered": "तुमची नोंदणी झाली आहे",
    "ev.detail.date": "तारीख",
    "ev.detail.venue": "ठिकाण",
    "ev.detail.seats": "जागा",
    "ev.detail.price": "किंमत",
    "ev.view_pass": "आपला पास पाहा",
    "ev.register_btn": "या कार्यक्रमासाठी नोंदणी करा",
    "ev.pass.title": "आपला इव्हेंट पास",
    "ev.pass.note": "प्रवेशासाठी हा QR कोड दाखवा.",
    "ev.open_to_all": "सर्व सदस्यांसाठी खुलं",
    "ev.pay_at_venue": "ठिकाणी पेमेंट (COD)",
    "ld.label": "नेतृत्व मार्ग",
    "ld.title.1": "उठा. नेतृत्व करा.",
    "ld.title.2": "प्रेरणा बना.",
    "ld.subtitle": "आपली टीम वाढवा, बोनस मिळवा आणि आपल्या शहराची शक्ती बना.",
    "ld.path_heading": "शक्ती मार्ग",
    "ld.path_hint": "फायदे आणि अटी पाहण्यासाठी कोणत्याही भूमिकेवर टॅप करा",
    "ld.next_milestone": "आपलं पुढचं लक्ष्य",
    "ld.next_become": "व्हा एक",
    "ld.team": "आपली टीम",
    "ld.team.sub": "ज्या महिलांना तुम्ही जोडले",
    "ld.bonus": "नेतृत्व बोनस",
    "ld.bonus.sub": "टीम कार्यातून मिळवलेले",
    "ld.rank": "आपली रँक",
    "ld.rank.next": "पुढे:",
    "ld.rank.top": "मार्गाच्या शिखरावर 👑",
    "ld.rank.signin": "आपली रँक पाहण्यासाठी साइन इन करा",
    "ld.tab.team": "माझी टीम",
    "ld.tab.board": "लीडरबोर्ड",
    "ld.empty_signin.title": "आपली टीम पाहण्यासाठी साइन इन करा",
    "ld.empty_signin.sub": "तुम्ही जोडलेल्या सर्वांचा आणि आपल्या नेतृत्व बोनसचा मागोवा घ्या.",
    "ld.empty_team.title": "अजून कोणतेही टीम सदस्य नाहीत",
    "ld.empty_team.sub": "आपला रेफरल कोड शेअर करा आणि नेतृत्व बोनस अनलॉक करा.",
    "ld.detail.unlock": "कसे अनलॉक करायचे",
    "ld.detail.benefits": "फायदे",
    "ld.detail.resp": "जबाबदाऱ्या",
    "ld.points": "गुण",
    "rc.label": "गौरव भिंत",
    "rc.title.1": "आमच्या",
    "rc.title.2": "शक्ती तारका",
    "rc.subtitle": "त्या महिलांना मानवंदना ज्या आपल्या नेतृत्वाने, कलेने आणि जिद्दीने इतरांना उभं करतात.",
    "rc.tab.leaders": "अग्रगण्य नेत्या",
    "rc.tab.sellers": "अग्रगण्य विक्रेत्या",
    "rc.tab.badges": "बॅज",
    "rc.team_bonus": "टीम बोनस",
    "rc.points": "गुण",
    "rc.sales": "विक्री",
    "rc.products": "उत्पादने",
    "rc.loading.leaders": "अग्रगण्य नेत्या लोड होत आहेत...",
    "rc.loading.sellers": "अग्रगण्य विक्रेत्या लोड होत आहेत...",
    "rc.loading.badges": "उपलब्धी लोड होत आहेत...",
    "rc.empty.leaders.title": "अजून कोणत्याही नेत्या नाहीत",
    "rc.empty.leaders.sub": "आपल्या शहरात पहिल्या उठून नेतृत्व करा.",
    "rc.empty.sellers.title": "अजून कोणतीही विक्री नाही",
    "rc.empty.sellers.sub": "पहिली विक्री करून इथे जागा मिळवा.",
    "rc.empty.badges.title": "अजून कोणतेही बॅज नाहीत",
    "rc.empty.badges.sub": "पोस्ट करा, विका आणि शिका — आपला पहिला बॅज मिळवा.",
    "rc.members_earned": "सदस्यांनी हे मिळवले",
    "earn.label": "कमाई",
    "earn.title.1": "तीन उत्पन्न स्रोत.",
    "earn.title.2": "एक व्यासपीठ.",
    "earn.subtitle": "उत्पादन विक्री, रेफरल आणि नेतृत्व टीममधून कमवा — ₹१०० नंतर बँकेत काढा.",
    "earn.cta": "कमाई सुरू करा",
    "common.loading": "लोड होत आहे...",
    "stats.sisters": "सक्रिय बहिणी",
    "stats.earnings": "वितरित कमाई",
    "stats.cities": "जोडलेली शहरे",
    "auth.signin_to": "{action}साठी साइन इन करा",
    "auth.action.sell": "उत्पादन विकण्या",
    "auth.action.cart": "कार्टमध्ये जोडण्या",
    "auth.action.post": "समुदायात शेअर करण्या",
    "auth.action.like": "पोस्ट लाइक करण्या",
    "auth.action.comment": "टिप्पणी करण्या",
    "auth.action.events": "कार्यक्रमासाठी नोंदणी करण्या",
    "auth.action.continue": "पुढे जाण्या",
    "toast.product_listed": "उत्पादन सूचीत आले!",
    "toast.product_failed": "उत्पादन जोडण्यात अडचण",
    "toast.product_added_cart": "{name} कार्टमध्ये जोडले",
    "toast.own_product": "हे आपलंच उत्पादन आहे",
    "toast.post_shared": "पोस्ट समुदायात शेअर झाली!",
    "toast.post_failed": "पोस्ट करण्यात अडचण",
    "toast.like_failed": "लाइक अपडेट झाले नाही. परत प्रयत्न करा.",
    "toast.comment_failed": "टिप्पणी पोस्ट झाली नाही. परत प्रयत्न करा.",
    "toast.event_registered": "नोंदणी झाली! तुम्ही तिथे भेटाल.",
    "toast.event_failed": "नोंदणी होऊ शकली नाही",
    "toast.products_failed": "उत्पादने लोड होऊ शकली नाहीत",
    "toast.events_failed": "कार्यक्रम लोड होऊ शकले नाहीत",
    "toast.feed_failed": "फीड लोड होऊ शकली नाही",
    "toast.name_price_required": "नाव आणि किंमत आवश्यक",
    "auth.back": "होमवर परत",
    "auth.welcome_back": "पुन्हा स्वागत",
    "auth.join.1": "शक्ती विंग्स मध्ये",
    "auth.join.2": "सहभागी व्हा",
    "auth.sub.login": "आपला प्रवास सुरू ठेवण्यासाठी साइन इन करा",
    "auth.sub.signup": "कमवा, शिका आणि नेतृत्व करा — आजच सुरुवात करा",
    "auth.tab.login": "लॉगिन",
    "auth.tab.signup": "साइन अप",
    "auth.tab.otp": "OTP",
    "auth.field.email": "ईमेल",
    "auth.field.password": "पासवर्ड",
    "auth.field.name": "पूर्ण नाव",
    "auth.field.mobile": "मोबाइल",
    "auth.field.city": "शहर",
    "auth.field.state": "राज्य",
    "auth.field.referral": "रेफरल कोड (पर्यायी)",
    "auth.field.otp_mobile": "मोबाइल क्रमांक",
    "auth.field.otp_code": "OTP टाका",
    "auth.placeholder.mobile": "10-अंकी मोबाइल",
    "auth.placeholder.otp": "6-अंकी OTP",
    "auth.btn.signin": "साइन इन",
    "auth.btn.create": "खाते तयार करा",
    "auth.btn.send_otp": "OTP पाठवा",
    "auth.btn.verify": "पडताळून पुढे जा",
    "auth.try_demo": "नमुना सदस्य लॉगिन वापरून पाहा",
    "auth.otp.note": "तुमच्या नंबरवर 6-अंकी कोड पाठवू.",
    "auth.otp.code_is": "तुमचा पडताळणी कोड:",
    "auth.otp.change_number": "नंबर बदला",
    // Phone-first passwordless auth (v2)
    "auth.tab.mobile": "मोबाईल OTP",
    "auth.tab.email": "ईमेल",
    "auth.sub.otp": "तुमच्या मोबाईल नंबरने लॉगिन करा किंवा नवीन अकाउंट तयार करा.",
    "auth.field.mobile_label": "मोबाईल क्रमांक",
    "auth.field.language": "पसंतीची भाषा",
    "auth.otp.enter_hint": "10-अंकी भारतीय मोबाईल. आम्ही 6-अंकी OTP पाठवू.",
    "auth.otp.sent": "{mobile} वर OTP पाठवला",
    "auth.otp.sent_mock": "OTP (dev): {otp}",
    "auth.otp.sent_to": "OTP पाठवला",
    "auth.otp.dev_mock_hint": "डेवलपमेंट OTP (auto-filled)",
    "auth.otp.never_share": "हा OTP कधीही कोणालाही सांगू नका. Shakti Wings टीम तुमच्याकडून OTP मागत नाही.",
    "auth.otp.not_received": "मिळाला नाही? पुन्हा पाठवा",
    "auth.otp.resend_in": "पुन्हा पाठवण्यास",
    "auth.otp.try_whatsapp": "WhatsApp OTP वापरा",
    "auth.otp.verified": "मोबाईल सत्यापित",
    "auth.terms.prefix": "मी",
    "auth.terms.tos": "सेवा अटी",
    "auth.terms.and": "आणि",
    "auth.terms.privacy": "गोपनीयता धोरण",
    "auth.terms.suffix": "ाशी सहमत आहे.",
    "auth.terms.age": "मी १८ वर्षे किंवा त्याहून अधिक वयाची/वयाचा असल्याची पुष्टी करते/करतो.",
    // Legal pages
    "legal.home": "मुख्यपृष्ठ",
    "legal.back_home": "मुख्यपृष्ठावर परत",
    "legal.last_updated": "शेवटचे अद्यतन",
    "legal.terms": "सेवा अटी",
    "legal.privacy": "गोपनीयता धोरण",
    "legal.delete_account": "खाते हटवा",
    "auth.err.login_failed": "लॉगिन अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
    "auth.err.signup_failed": "साइनअप अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
    "auth.err.send_failed": "OTP पाठवता आला नाही. कृपया पुन्हा प्रयत्न करा.",
    "auth.err.invalid_otp": "चुकीचा OTP",
    "auth.err.terms_required": "पुढे जाण्यासाठी कृपया अटी आणि गोपनीयता धोरणास सहमती द्या.",
    // User Guide & Help Center
    "guide.badge": "युजर गाइड आणि हेल्प सेंटर",
    "guide.heading.before": "",
    "guide.heading.after": " कसे वापरावे",
    "guide.intro": "तुम्हाला जे काही जाणून घ्यायचे आहे — कसे विकायचे, कसे विकत घ्यायचे, कसे कमवायचे, आमचे कम्युनिटी नियम आणि नेहमीच्या प्रश्नांची उत्तरे.",
    "guide.step": "पायरी",
    "guide.lang_label": "भाषा चुनें / भाषा निवडा / Select Language",
    "guide.join_cta": "आत्ताच Shakti Wings जॉइन करा",
    "guide.whatsapp_help": "अजून प्रश्न आहेत? आम्हाला WhatsApp करा",
    "guide.empty": "गाइड तयार होत आहे. कृपया थोड्या वेळाने पुन्हा पाहा.",
  },
};
